import { PlaybooksService } from '@/services/playbook'
import { ApiErrorResponse, ApiIndividualResponse } from '@/types/api'
import { ApiPlaybookCategory } from '@/types/playbook'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

interface UsePlaybookCategoriesOptions {
  queryOptions?: Omit<
    UseQueryOptions<
      ApiIndividualResponse<ApiPlaybookCategory[]>,
      ApiErrorResponse,
      ApiIndividualResponse<ApiPlaybookCategory[]>
    >,
    'queryKey' | 'queryFn'
  >
}

const FIVE_MINUTES = 1000 * 60 * 5

export const usePlaybookCategories = ({
  queryOptions = {},
}: UsePlaybookCategoriesOptions = {}) => {
  return useQuery({
    queryKey: ['playbooks', 'categories'],
    queryFn: PlaybooksService.getPlaybookCategories,
    staleTime: FIVE_MINUTES,
    ...queryOptions,
  })
}
